export const groupLegsByAirlineReference = (order, segmentIndex, legs) => {
    if (!order.airOrder.airlineReferencesByLeg?.length || !legs.length) {
        return [];
    }
    const groups = [];
    const referenceToLegIndices = new Map();
    order.airOrder.airlineReferencesByLeg.forEach((airlineRef) => {
        const legIndicesForReference = [];
        airlineRef.legIdentifier.forEach((identifier) => {
            if (identifier.segmentIndex === segmentIndex) {
                legIndicesForReference.push(identifier.legIndex);
            }
        });
        if (legIndicesForReference.length > 0) {
            referenceToLegIndices.set(airlineRef.reference, legIndicesForReference);
        }
    });
    referenceToLegIndices.forEach((legIndices, reference) => {
        const groupLegs = legIndices
            .map((legIndex) => ({
            leg: legs[legIndex],
            legIndex
        }))
            .filter((item) => item.leg);
        if (groupLegs.length > 0) {
            groupLegs.sort((a, b) => a.legIndex - b.legIndex);
            const firstLeg = groupLegs[0].leg;
            const lastLeg = groupLegs[groupLegs.length - 1].leg;
            const journeyLeg = {
                ...firstLeg,
                arrivalAirport: lastLeg.arrivalAirport,
                arrivalTime: lastLeg.arrivalTime,
                arrivalTimeTz: lastLeg.arrivalTimeTz
            };
            groups.push({
                airlineReference: reference,
                legs: groupLegs,
                journeyLeg,
                representativeLegIndex: groupLegs[0].legIndex,
                startLegIndex: groupLegs[0].legIndex
            });
        }
    });
    return groups.sort((a, b) => a.startLegIndex - b.startLegIndex);
};
